module.exports = __webpack_public_path__ + "de8b7431b74642e830af4d4f4b513ec9.woff";


//////////////////
// WEBPACK FOOTER
// ./node_modules/typeface-roboto/files/roboto-latin-500.woff
// module id = 668
// module chunks = 0